module.exports = __webpack_public_path__ + "img/study-comp-1.e4a2c54b.png";